module.exports = __webpack_public_path__ + "media/images/stock_groups/e8cc-6acfc701ca1a90ee071693106134030a.svg";